import { SET_PRE_LOGIN } from "../ActionTypes";

export const setPreLogin = data => dispatch => {
    dispatch({
        type:SET_PRE_LOGIN,
        payload:data
    })
}